import { render, staticRenderFns } from "./DescargarEscritorio.vue?vue&type=template&id=40024664"
import script from "./DescargarEscritorio.vue?vue&type=script&lang=js"
export * from "./DescargarEscritorio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports